/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { useState, useContext, useEffect, useRef, useMemo } from 'react'
import './tablecomponent.scss'
import { FaPlus } from "react-icons/fa6";
import { FaMinus } from "react-icons/fa";
import DynamicTableHeader from './DynamicTableHeader';
import DynamicTableRow from './DynamicTableRow';
import { AppContext } from '../../contexts/AppContext';
import useForecastUiData from '../../hooks/useForecastUiDatas';
import Spinner from '../Spinner';
import useFetchWeeklyReport from '../../hooks/useFetchWeeklyReport';
import { EditContext } from '../RightCompoent';
import { buildMonthLastWeekIndexMap } from '../../utils/aggregateMonthlyColumns';
import DownloadExcel from "../../utils/download";
import { MAX_WEEK_NUM } from "../../config";
import { displayProductLabel } from '../../utils/demoProductLabels.js';

export default function StatisticalForecastTable({ selectedItemName, refreshCount, onRefreshComplete, isEditEnabled }) {
    const tableWrapperRef = useRef(null);
    const didInitialProjLoad = useRef(false);

    const suppressScrollRef = useRef(false);
    const suppressTimeoutRef = useRef(false);

    const excelRef = useRef(null);
    const lastDownloadRef = useRef(0);

    const [plusIcons, setPlusIcons] = useState(false)
    const [stockoutlet, setStockoutlet] = useState(false)
    const [forecastedTP, setForecastedTP] = useState(false)
    const [exposure, setExposure] = useState(false)
    const [dbrDosvalue, setDbrDosvalue] = useState(false)

    const [highlightedInputRow, setHighlightedInputRow] = useState(null);
    const [highlightedProjIdx, setHighlightedProjIdx] = useState(null);

    const { editingInputsValues, setEditingInputsValues,
        projectedValues, setProjectedValues,
        projectedValuesLoaded, setProjectedValuesLoaded, setHasEdited, setCanSave, requestOpenInput, setRequestOpenInput } = useContext(EditContext);

    console.log("From top statistical table comp", projectedValues)

    const { PastActualsOneValue, PastActualsTwoValue, PastForecastOneValue, PastForecastTwoValue, versionWeekNo } = useContext(AppContext);

    const {
        forecastData,
        weeklyData,
        stockMonthlyData,
        stockWeeklyData,
        driversMonthlyData,
        driversWeeklyData,
        inputsMonthlyData,
        inputsWeeklyData,
        allDefaultInputVals,
        foreCastTertiaryMonthlyData,
        foreCastTertiaryWeeklyData,
        pastForecast,
        pastActualsMonthlyAggregation,
        pastForecastMonthlyAggregation,
        projectedMonthlyAggregation,
        aggregations_union_arr,
        currentWeekNumber,
        pastActualsEnd,
        pastActualsCount,
        forecastCount,
        projectionCount,
        finalWeek,
        weeklyRanges,
        week_after_launch,
        projectedValues: projectedVals,
        loading: weeklyLoading,
        error: weeklyError,
        refetch: reloadAll
    } = useFetchWeeklyReport(selectedItemName);

    // const weeklyRangesLocal = weeklyRanges || [];
    // const actualsMonthsMeta = (pastActualsMonthlyAggregation?.months) || ([]);

    console.log("values sss va", weeklyRanges, typeof weeklyRanges, pastActualsMonthlyAggregation,
        pastForecastMonthlyAggregation,
        projectedMonthlyAggregation)

    // normalize weeklyRanges that may come as:
    // - array [...]
    // - object with numeric keys { "1": {...}, "2": {...} }
    // - wrapper { weeks: [...] } or { data: [...] }
    const weeklyRangesLocal = useMemo(() => {
        if (!weeklyRanges) return [];

        // already an array -> return as-is (assumed ordered)
        if (Array.isArray(weeklyRanges)) return weeklyRanges;

        // wrapper shapes
        if (typeof weeklyRanges === 'object') {
            if (Array.isArray(weeklyRanges.weeks)) return weeklyRanges.weeks;
            if (Array.isArray(weeklyRanges.data)) return weeklyRanges.data;

            // object with numeric keys (e.g. "1": {...}, "2": {...})
            const entries = Object.entries(weeklyRanges || {});
            // if keys look numeric, sort by numeric key
            const numeric = entries.every(([k]) => String(Number(k)) === k);
            if (numeric && entries.length) {
                entries.sort((a, b) => Number(a[0]) - Number(b[0]));
                return entries.map(([, v]) => v);
            }

            // fallback: return Object.values (best effort)
            return Object.values(weeklyRanges);
        }

        return [];
    }, [weeklyRanges]);


    const actualsMonthsMeta = useMemo(() => {
        const m = pastActualsMonthlyAggregation?.months;
        return Array.isArray(m) ? m : [];
    }, [pastActualsMonthlyAggregation?.months]);

    const pastForecastMonthsMeta = useMemo(() => {
        const m = pastForecastMonthlyAggregation?.months;
        return Array.isArray(m) ? m : [];
    }, [pastForecastMonthlyAggregation?.months]);

    const projectedMonthsMeta = useMemo(() => {
        const m = projectedMonthlyAggregation?.months;
        return Array.isArray(m) ? m : [];
    }, [projectedMonthlyAggregation?.months]);

    console.log("hioue", weeklyRangesLocal, actualsMonthsMeta, pastForecastMonthsMeta, projectedMonthsMeta)

    const memoMapsPastActuals = useMemo(() => {
        if (!weeklyRangesLocal.length || !actualsMonthsMeta.length) {
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
        try {
            return buildMonthLastWeekIndexMap(weeklyRangesLocal, actualsMonthsMeta) ?? { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        } catch (err) {
            console.warn("buildMonthLastWeekIndexMap threw:", err);
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
    }, [weeklyRangesLocal, actualsMonthsMeta]);

    const memoMapsPastForecast = useMemo(() => {
        if (!weeklyRangesLocal.length || !pastForecastMonthsMeta.length) {
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
        try {
            return buildMonthLastWeekIndexMap(weeklyRangesLocal, pastForecastMonthsMeta) ?? { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        } catch (err) {
            console.warn("buildMonthLastWeekIndexMap (pastForecast) threw:", err);
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
    }, [weeklyRangesLocal, pastForecastMonthsMeta]);

    const memoMapsProjected = useMemo(() => {
        if (!weeklyRangesLocal.length || !projectedMonthsMeta.length) {
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
        try {
            console.log("projectedMonthsMeta", weeklyRangesLocal, projectedMonthsMeta)
            return buildMonthLastWeekIndexMap(weeklyRangesLocal, projectedMonthsMeta) ?? { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        } catch (err) {
            console.warn("buildMonthLastWeekIndexMap (projected) threw:", err);
            return { lastWeekIndexToMonthIdx: {}, monthIdxToLastWeek: [] };
        }
    }, [weeklyRangesLocal, projectedMonthsMeta]);

    const lastWeekIndexToMonthIdxBySection = {
        pastActuals: memoMapsPastActuals?.lastWeekIndexToMonthIdx ?? {},
        pastForecast: memoMapsPastForecast?.lastWeekIndexToMonthIdx ?? {},
        projected: memoMapsProjected?.lastWeekIndexToMonthIdx ?? {},
    };

    const monthIdxToLastWeekBySection = {
        pastActuals: memoMapsPastActuals?.monthIdxToLastWeek ?? [],
        pastForecast: memoMapsPastForecast?.monthIdxToLastWeek ?? [],
        projected: memoMapsProjected?.monthIdxToLastWeek ?? [],
    }


    const monthsMetaBySection = {
        pastActuals: actualsMonthsMeta,
        pastForecast: pastForecastMonthsMeta,
        projected: projectedMonthsMeta,
    };
    console.log("monthIdxToLastWeekBySection", monthIdxToLastWeekBySection, monthsMetaBySection)


    // const { lastWeekIndexToMonthIdx, monthIdxToLastWeek } = memoMapsPastActuals;
    // console.log("right values", lastWeekIndexToMonthIdx, monthIdxToLastWeek)

    // ----------------- helper methods for inputs aggregations values---------------------
    const getMonthIdxForGlobalWeek = (sectionKey = 'pastActuals', globalIdx) => {
        if (!globalIdx && globalIdx !== 0) return undefined;
        const key = (sectionKey || '').toString();
        const canonical = key === 'pastActuals' || key.toLowerCase().includes('actual') ? 'pastActuals' :
            (key === 'pastForecast' || key.toLowerCase().includes('forecast')) ? 'pastForecast' :
                (key === 'projected' || key.toLowerCase().includes('project')) ? 'projected' : 'pastActuals';

        const map = lastWeekIndexToMonthIdxBySection[canonical === 'pastActuals' ? 'pastActuals' : (canonical === 'pastForecast' ? 'pastForecast' : 'projected')];
        if (!map) return undefined;
        // support Map or plain object
        if (typeof map.get === 'function') return map.get(globalIdx);
        return map[String(globalIdx)];
    };

    const findMonthlyArrayForInput = (aggObj, inputName) => {
        if (!aggObj || !inputName) return null;
        const target = String(inputName).toLowerCase();
        // check several likely sections
        const sections = ['input', 'kpis', 'drivers', 'stock', 'stocks', 'forecast_tertiary', 'exposure', 'inputs'];
        for (const sec of sections) {
            const arr = aggObj[sec];
            if (!Array.isArray(arr)) continue;
            for (const item of arr) {
                if (!item) continue;
                if (String(item.input_name || '').toLowerCase() === target && Array.isArray(item.val)) {
                    return item.val; // aggregated monthly values array (aligned with months meta)
                }
            }
        }
        // if aggObj is an array itself of named entries
        if (Array.isArray(aggObj)) {
            for (const item of aggObj) {
                if (!item) continue;
                if (String(item.input_name || '').toLowerCase() === target && Array.isArray(item.val)) {
                    return item.val;
                }
            }
        }
        return null;
    };

    const renderWeeklyWithMonthlyForInput = (valuesArr = [], sectionKey, baseGlobalIndex = 0, inputName) => {
        const cells = [];
        // choose the aggregation object per section
        let aggObj = null;
        if (sectionKey === 'pastActuals') aggObj = pastActualsMonthlyAggregation;
        else if (sectionKey === 'pastForecast') aggObj = pastForecastMonthlyAggregation;
        else if (sectionKey === 'projected') aggObj = projectedMonthlyAggregation;

        const monthlyVals = findMonthlyArrayForInput(aggObj, inputName); // may be null

        for (let i = 0; i < (valuesArr?.length || 0); i++) {
            const v = valuesArr[i];
            const cellClass = (sectionKey === 'pastActuals') ? 'past_actuals_2' : (sectionKey === 'pastForecast' ? 'past_actuals_3' : 'projected');

            // weekly cell
            cells.push(
                <td key={`${sectionKey}-wk-${baseGlobalIndex + i}`} className={cellClass}>
                    {v === 0 ? '-' : (v == null ? '-' : (typeof v === 'number' ? v.toLocaleString('en-IN') : v))}
                </td>
            );

            // check if this is last week-of-month (global index)
            const globalIdx = baseGlobalIndex + i;
            const monthIdx = getMonthIdxForGlobalWeek(sectionKey, globalIdx);
            if (monthIdx !== null && monthIdx !== undefined) {
                const mVal = monthlyVals ? monthlyVals[monthIdx] : null;
                cells.push(
                    <td key={`${sectionKey}-mon-${globalIdx}`} className={`${cellClass} monthly-agg`}>
                        {mVal == null || mVal === 0 ? '-' : (typeof mVal === 'number' ? mVal.toLocaleString('en-IN') : mVal)}
                    </td>
                );
            }
        }

        return cells;
    };


    // -----------------calculation of colspan for sections----------------------------
    const mkNormalize = arr => (Array.isArray(arr) ? arr.map(v => (v === null || v === undefined) ? null : Number(v)) : []);

    const actualsMonthLastWeekIdxs = mkNormalize(monthIdxToLastWeekBySection.pastActuals);
    const pastForecastMonthLastWeekIdxs = mkNormalize(monthIdxToLastWeekBySection.pastForecast);
    const projectedMonthLastWeekIdxs = mkNormalize(monthIdxToLastWeekBySection.projected);

    // global index ranges (0-based) for each section
    const pastActualsStart = 0;
    const pastActualsEndIndex = Math.max(-1, (pastActualsCount || 0) - 1);

    const pastForecastStart = (pastActualsCount || 0);
    const pastForecastEndIndex = Math.max(-1, (pastActualsCount || 0) + (forecastCount || 0) - 1);

    const projectedStart = (pastActualsCount || 0) + (forecastCount || 0);
    const projectedEndIndex = Math.max(-1, projectedStart + (projectionCount || 0) - 1);

    const countExtraMonths = (arr, start, end) => {
        if (!Array.isArray(arr) || arr.length === 0) return 0;
        let c = 0;
        for (let idx = 0; idx < arr.length; idx++) {
            const lw = arr[idx];
            if (lw === null || lw === undefined || Number.isNaN(lw)) continue;
            if (lw >= start && lw <= end) c += 1;
        }
        return c;
    };

    const extraPastActualsMonths = countExtraMonths(actualsMonthLastWeekIdxs, pastActualsStart, pastActualsEndIndex);
    const extraPastForecastMonths = countExtraMonths(pastForecastMonthLastWeekIdxs, pastForecastStart, pastForecastEndIndex);
    const extraProjectedMonths = projectedMonthLastWeekIdxs.length;
    // const extraProjectedMonths = countExtraMonths(projectedMonthLastWeekIdxs, projectedStart, projectedEndIndex);

    const basePastActualsWeeks = pastActualsCount || 0;
    const basePastForecastWeeks = forecastCount || 0;
    const baseProjectedWeeks = projectionCount || 0;

    const colSpanPastActuals = basePastActualsWeeks + extraPastActualsMonths;
    const colSpanPastForecast = basePastForecastWeeks + extraPastForecastMonths;
    const colSpanProjected = baseProjectedWeeks + extraProjectedMonths;
    // -----------------calculation of colspan for sections[END]----------------------------

    useEffect(() => {
        if (projectedVals) {
            console.log("From the useeffect to see", projectedValues)
            setProjectedValues(projectedVals)
            setProjectedValuesLoaded(true)
            setEditingInputsValues(projectedVals?.input)
        }
    }, [projectedVals]);

    useEffect(() => {
        if (isEditEnabled && projectedValuesLoaded) {
            const t = setTimeout(() => {
                setHighlightedInputRow(0);
                setHighlightedProjIdx(0);
            }, 60);
            return () => clearTimeout(t);
        }
        if (!isEditEnabled) {
            setHighlightedInputRow(null);
            setHighlightedProjIdx(null);
        }
    }, [isEditEnabled, projectedValuesLoaded]);

    useEffect(() => {
        if (highlightedInputRow == null || highlightedProjIdx == null) return;
        const sel = document.querySelector(
            `tr[data-row-index="${highlightedInputRow}"] td[data-projection-index="${highlightedProjIdx}"] input`
        );
        if (sel) {
            sel.focus();
            try { const len = sel.value?.length || 0; sel.setSelectionRange(len, len); } catch (e) { }
        }
    }, [highlightedInputRow, highlightedProjIdx]);

    useEffect(() => {
        didInitialProjLoad.current = false;
    }, [selectedItemName]);

    console.log("before sending it to useForecastUiData", projectedValues)

    const { kpi, stock, forecastTertiary, drivers, exposure: exposureProps, inputs } = useForecastUiData(
        forecastData, weeklyData, stockMonthlyData, stockWeeklyData, pastActualsCount,
        forecastCount, projectionCount, driversMonthlyData, driversWeeklyData,
        inputsMonthlyData, inputsWeeklyData, allDefaultInputVals,
        foreCastTertiaryMonthlyData, foreCastTertiaryWeeklyData,
        pastForecast, projectedValues, editingInputsValues, week_after_launch
    );

    //added logic to prevent multiple downloads on rapid clicks

    const runDownload = () => {
        const now = Date.now();
        if (now - lastDownloadRef.current < 800) {
            return;
        }
        lastDownloadRef.current = now;
        excelRef.current.downloadExcel(displayProductLabel(selectedItemName), weeklyRanges);
    };

    useEffect(() => {
        if (refreshCount === 0) return;
        Promise.all([reloadAll()]).finally(() => onRefreshComplete())
    }, [refreshCount]);

    // ---------- Scroll helper functions ----------
    function findScrollContainer(el) {
        if (!el) return null;
        let node = el;
        while (node && node !== document.body && node !== document.documentElement) {
            const style = window.getComputedStyle(node);
            const overflowX = style.overflowX;
            const canScrollX = node.scrollWidth > node.clientWidth && (overflowX === 'auto' || overflowX === 'scroll' || overflowX === 'overlay');
            if (canScrollX) return node;
            node = node.parentElement;
        }
        return document.scrollingElement || document.documentElement;
    }
    function getRelativeLeft(child, container) {
        if (!child || !container) return 0;
        let left = 0;
        let node = child;
        while (node && node !== container && node !== document.body) {
            left += node.offsetLeft || 0;
            node = node.offsetParent;
        }
        if (node === container) return left;
        const childRect = child.getBoundingClientRect();
        const contRect = container.getBoundingClientRect();
        return (childRect.left - contRect.left) + container.scrollLeft;
    }
    function getRelativeTop(child, container) {
        if (!child || !container) return 0;
        let top = 0;
        let node = child;
        while (node && node !== container && node !== document.body) {
            top += node.offsetTop || 0;
            node = node.offsetParent;
        }
        if (node === container) return top;
        const childRect = child.getBoundingClientRect();
        const contRect = container.getBoundingClientRect();
        return (childRect.top - contRect.top) + container.scrollTop;
    }

    // ensure projection stays fully visible for a short period (retries)
    function ensureProjectionVisibleWithRetries(container, projTh, desiredLeft, maxAttempts = 10, intervalMs = 150) {
        if (!container || !projTh) return () => { };
        let attempts = 0;
        const intervalId = setInterval(() => {
            attempts += 1;
            const contRect = container.getBoundingClientRect();
            const thRect = projTh.getBoundingClientRect();
            const paddingLeft = 2, paddingRight = 2;
            const fullyVisible = (thRect.left >= contRect.left + paddingLeft) && (thRect.right <= contRect.right - paddingRight);
            if (!fullyVisible && attempts <= maxAttempts) {
                try {
                    const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
                    const target = Math.min(maxScrollLeft, Math.max(0, Math.round(desiredLeft)));
                    container.scrollTo({ left: target, behavior: 'smooth' });
                } catch (e) { /* ignore */ }
            } else {
                clearInterval(intervalId);
            }
            if (attempts >= maxAttempts) clearInterval(intervalId);
        }, intervalMs);
        setTimeout(() => { /* first tick already handled by interval */ }, 60);
        return () => clearInterval(intervalId);
    }

    function scrollProjectionIntoViewOnce() {
        try {
            const projTh = document.querySelector('th[data-projection-index="0"]') ||
                (tableWrapperRef.current && tableWrapperRef.current.querySelector('th[data-projection-index="0"]'));
            if (!projTh) return;
            let container = tableWrapperRef.current || document.querySelector('.tableUI') || document.body;
            if (container && container.scrollWidth <= container.clientWidth) {
                const alt = findScrollContainer(projTh);
                if (alt) container = alt;
            }
            if (!container) container = document.scrollingElement || document.documentElement;
            if (container.scrollWidth > container.clientWidth) {
                const contRect = container.getBoundingClientRect();
                const thRect = projTh.getBoundingClientRect();

                let fixedLeftEl = (container.querySelector && container.querySelector('thead .fixed-left')) ||
                    (container.querySelector && container.querySelector('.fixed-left')) ||
                    document.querySelector('.fixed-left');
                if (fixedLeftEl && fixedLeftEl.tagName && fixedLeftEl.tagName.toLowerCase() === 'td') {
                    const anc = fixedLeftEl.closest('th') || fixedLeftEl.closest('td');
                    if (anc) fixedLeftEl = anc;
                }
                const fixedLeftWidth = fixedLeftEl ? Math.round(fixedLeftEl.getBoundingClientRect().width) : 0;

                const projLeftRel = (thRect.left - contRect.left) + container.scrollLeft;
                const leftPad = 6;
                const rawTarget = Math.round(projLeftRel - fixedLeftWidth - leftPad);
                const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
                const targetLeft = Math.min(maxScrollLeft, Math.max(0, rawTarget));
                container.scrollTo({ left: targetLeft, behavior: 'smooth' });
            } else {
                try { projTh.scrollIntoView({ inline: 'start', behavior: 'smooth' }); } catch (e) { }
            }
        } catch (e) { /* ignore */ }
    }

    useEffect(() => {
        if (!isEditEnabled) return;

        let cancelled = false;
        let stabilityCleanup = null;
        let debounceTimer = null;

        // Small paddings you can tweak
        const leftPadding = 8;
        const topPadding = 8;

        // attempt counter / retry
        let attempts = 0;
        const maxAttempts = 14;

        const performScroll = () => {
            if (cancelled) return;
            attempts++;

            // Prefer header cell in last THEAD row (aligns exactly with body columns)
            const headerProjSelector = 'thead tr:last-child [data-projection-index="0"]';
            const anyProjSelector = '[data-projection-index="0"]';

            let projEl =
                (tableWrapperRef.current && tableWrapperRef.current.querySelector(headerProjSelector)) ||
                document.querySelector(headerProjSelector) ||
                (tableWrapperRef.current && tableWrapperRef.current.querySelector(anyProjSelector)) ||
                document.querySelector(anyProjSelector);

            // If projection element not present yet, schedule a retry (up to maxAttempts)
            if (!projEl) {
                if (attempts < maxAttempts) {
                    setTimeout(performScroll, 120);
                }
                return;
            }

            // Choose the scroll container
            let container = tableWrapperRef.current || document.querySelector('.tableUI') || document.body;
            if (container && container.scrollWidth <= container.clientWidth) {
                const alt = findScrollContainer(projEl);
                if (alt) container = alt;
            }
            if (!container) container = document.scrollingElement || document.documentElement;

            try {
                // measure rects
                const contRect = container.getBoundingClientRect();
                const elRect = projEl.getBoundingClientRect();

                // fixed-left width (try header first)
                let fixedLeftEl = (container.querySelector && container.querySelector('thead .fixed-left')) ||
                    (container.querySelector && container.querySelector('.fixed-left')) ||
                    document.querySelector('.fixed-left');
                if (fixedLeftEl && fixedLeftEl.tagName && fixedLeftEl.tagName.toLowerCase() === 'td') {
                    const anc = fixedLeftEl.closest('th') || fixedLeftEl.closest('td');
                    if (anc) fixedLeftEl = anc;
                }
                const fixedLeftWidth = fixedLeftEl ? Math.round(fixedLeftEl.getBoundingClientRect().width) : 0;

                // compute targetLeft
                const elLeftRel = (elRect.left - contRect.left) + container.scrollLeft;
                const leftPadding = 6; // tweak this
                const rawTarget = Math.round(elLeftRel - fixedLeftWidth - leftPadding);
                const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
                let targetLeft = Math.min(maxScrollLeft, Math.max(0, rawTarget));

                // FIRST: apply immediate scroll (auto) so we can get deterministic state
                container.scrollTo({ left: targetLeft, behavior: 'auto' });

                // small check and corrective nudge (delayed, after layout settles)
                setTimeout(() => {
                    const newContRect = container.getBoundingClientRect();
                    const newElRect = projEl.getBoundingClientRect();
                    const desiredLeftEdge = newContRect.left + fixedLeftWidth + leftPadding;
                    const overshootPx = Math.round(newElRect.left - desiredLeftEdge);
                    // if the projection element ended up too far right, nudge left
                    if (overshootPx > 6) {
                        const nTarget = Math.max(0, container.scrollLeft - overshootPx - 4);
                        container.scrollTo({ left: nTarget, behavior: 'smooth' });
                    } else {
                        // optional: small smooth nudge to look nicer
                        container.scrollTo({ left: targetLeft, behavior: 'smooth' });
                    }
                }, 60);

                // vertical alignment - align the header near top
                const thead = (container.querySelector && container.querySelector('thead')) || null;
                const topTargetEl = thead || projEl;
                if (topTargetEl) {
                    const elementTop = getRelativeTop(topTargetEl, container);
                    const topPadding = 8;
                    const rawTop = Math.round(elementTop - topPadding);
                    const maxScrollTop = Math.max(0, container.scrollHeight - container.clientHeight);
                    const targetTop = Math.min(maxScrollTop, Math.max(0, rawTop));
                    container.scrollTo({ top: targetTop, behavior: 'smooth' });
                }

            } catch (err) {
                console.warn('performScroll error', err);
            }
        }; // performScroll

        // Debounced scheduler: call performScroll after DOM "quiet" period
        const schedule = (delay = 160) => {
            if (debounceTimer) clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => {
                performScroll();
            }, delay);
        };

        // initial attempt after tiny delay (gives browser chance to layout initial expansion)
        requestAnimationFrame(() => setTimeout(() => schedule(180), 40));

        // watch for DOM mutations inside the table wrapper to trigger scroll after layout stabilizes
        const targetNode = tableWrapperRef.current || document.querySelector('.tableUI');
        const observer = new MutationObserver(() => {
            if (suppressScrollRef.current) return;
            schedule(140);
        });
        if (targetNode) observer.observe(targetNode, { childList: true, subtree: true, attributes: true });

        // safety: also retry a few times if needed by scheduling more attempts (handled by stabilityCleanup)
        return () => {
            cancelled = true;
            if (debounceTimer) clearTimeout(debounceTimer);
            try { observer.disconnect(); } catch (e) { }
            try { if (typeof stabilityCleanup === 'function') stabilityCleanup(); } catch (e) { }
        };
    }, [isEditEnabled, pastActualsCount, forecastCount, projectionCount, projectedValuesLoaded, dbrDosvalue]);

    // ======= POST-PROCESSING SCROLL (unchanged, robust) =======
    useEffect(() => {
        if (!projectedValuesLoaded || isEditEnabled) return;

        if (!didInitialProjLoad.current) {
            didInitialProjLoad.current = true;
            return;
        }

        let cancelled = false;
        let attempts = 0;
        const maxAttempts = 12;

        const leftPadding = 8;
        const rightPadding = 8;

        let stabilityCleanup = null;

        const tryScroll = () => {
            if (cancelled) return;
            attempts += 1;

            const projTh = document.querySelector('th[data-projection-index="0"]') || (tableWrapperRef.current && tableWrapperRef.current.querySelector('th[data-projection-index="0"]'));
            const wrapper = tableWrapperRef.current || document.querySelector('.tableUI') || document.body;

            if (!projTh && attempts < maxAttempts) {
                requestAnimationFrame(() => setTimeout(tryScroll, 60));
                return;
            }

            let container = wrapper;
            if (!container) container = projTh ? findScrollContainer(projTh) : document.scrollingElement || document.documentElement;
            if (container && container.scrollWidth <= container.clientWidth) {
                const alt = projTh ? findScrollContainer(projTh) : null;
                if (alt) container = alt;
            }

            if (!projTh || !container) {
                if (attempts < maxAttempts) requestAnimationFrame(() => setTimeout(tryScroll, 60));
                return;
            }

            try {
                if (container.scrollWidth > container.clientWidth) {
                    const contRect = container.getBoundingClientRect();
                    const thRect = projTh.getBoundingClientRect();

                    let fixedLeftEl = container.querySelector('.fixed-left') || document.querySelector('.fixed-left');
                    if (fixedLeftEl && fixedLeftEl.tagName && fixedLeftEl.tagName.toLowerCase() === 'td') {
                        const ancestor = fixedLeftEl.closest('th') || fixedLeftEl.closest('td');
                        if (ancestor) fixedLeftEl = ancestor;
                    }
                    const fixedLeftWidth = fixedLeftEl ? fixedLeftEl.getBoundingClientRect().width : 0;

                    const projLeftRel = (thRect.left - contRect.left) + container.scrollLeft;
                    const rawTarget = Math.round(projLeftRel - fixedLeftWidth - leftPadding);

                    const thWidth = projTh.offsetWidth || (thRect.right - thRect.left);
                    const rightNeededTarget = Math.round(projLeftRel - (container.clientWidth - rightPadding - thWidth));
                    let targetLeft = Math.max(0, Math.max(rawTarget, rightNeededTarget));
                    const maxScrollLeft = Math.max(0, container.scrollWidth - container.clientWidth);
                    targetLeft = Math.min(maxScrollLeft, Math.max(0, targetLeft));

                    container.scrollTo({ left: targetLeft, behavior: 'smooth' });

                    if (stabilityCleanup) stabilityCleanup();
                    stabilityCleanup = ensureProjectionVisibleWithRetries(container, projTh, targetLeft, 14, 140);
                } else {
                    try { projTh.scrollIntoView({ inline: 'start', behavior: 'smooth' }); } catch (_) { }
                }
            } catch (err) {
                console.warn('[scroll-debug] horizontal scroll error', err);
            }
        };

        requestAnimationFrame(() => setTimeout(tryScroll, 30));

        return () => {
            cancelled = true;
            try { if (typeof stabilityCleanup === 'function') stabilityCleanup(); } catch (e) { }
        };
    }, [projectedValuesLoaded, isEditEnabled, pastActualsCount, forecastCount, projectionCount]);

    // UI toggles and input handling
    const toggleIcons = () => setPlusIcons(!plusIcons);
    const StockoutletHandle = () => setStockoutlet(!stockoutlet);
    const ForecastedTertParameters = () => setForecastedTP(!forecastedTP);
    const exposureFunction = () => setExposure(!exposure);
    const dbrDos = () => setDbrDosvalue(!dbrDosvalue);

    const handleInputEditChange = (inputName, wkIndx, updatedValue) => {
        let updatedFieldValue = updatedValue;
        if (updatedValue) updatedFieldValue = Number(updatedValue)
        if (isNaN(updatedFieldValue)) updatedFieldValue = 0;
        setEditingInputsValues(prev => {
            const updated = structuredClone(prev)
            updated[inputName][wkIndx] = updatedFieldValue;
            return updated;
        })
        setHasEdited(true);
        setCanSave(false);

        suppressScrollRef.current = true;
        if (suppressTimeoutRef.current) clearTimeout(suppressTimeoutRef.current);
        suppressTimeoutRef.current = setTimeout(() => {
            suppressScrollRef.current = false;
            suppressTimeoutRef.current = null;
            // optionally trigger one final alignment after typing stops
            try { scrollProjectionIntoViewOnce(); } catch (e) { /* ignore */ }
        }, 700); // 700ms after last keystroke, allow scrolls again
    }

    useEffect(() => {
        if (isEditEnabled && requestOpenInput) {
            // open the input section (if collapsed)
            setDbrDosvalue(true);
            // clear the one-off request
            try { setRequestOpenInput(false); } catch (e) { }
        }
    }, [isEditEnabled, requestOpenInput, setRequestOpenInput]);

    if (selectedItemName && (weeklyLoading || !projectedValuesLoaded) && refreshCount === 0) {
        return <div data-testid="loading-state" className="tableUI flex items-center justify-center" style={{ color: '#52525B', fontFamily: "'IBM Plex Sans', sans-serif", padding: '40px', fontSize: '0.85rem', fontWeight: 500, textTransform: 'uppercase', letterSpacing: '0.05em' }}>Loading weekly data for “{displayProductLabel(selectedItemName)}”<Spinner /></div>;
    }
    if (weeklyError) return <div data-testid="error-state" className='tableUI error flex items-center justify-center' style={{ color: '#FF3B30' }}>Failed to load stock data :{weeklyError}</div>

    return (
        <div className='tableUI' ref={tableWrapperRef}>
            {
                selectedItemName ?
                    <div className="flex justify-end mb-2">
                        <button data-testid="download-excel-button" onClick={runDownload} className="button-primary" style={{ fontFamily: "'IBM Plex Sans', sans-serif", fontWeight: 600, fontSize: '0.72rem', textTransform: 'uppercase', letterSpacing: '0.08em' }}>Download</button>

                        <DownloadExcel
                            ref={excelRef}
                            kpiData={kpi}
                            stockData={stock}
                            forecastTertiaryData={forecastTertiary}
                            driversData={drivers}
                            exposureData={exposureProps}
                            inputsData={inputs}
                            pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                            pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                            projectedMonthlyAggregation={projectedMonthlyAggregation}
                            fileName={`${displayProductLabel(selectedItemName)}_forecast.xlsx`}
                            countPastActuals={colSpanPastActuals}
                            countPastForecast={colSpanPastForecast}
                            countProjected={colSpanProjected}
                        />
                    </div>
                    : null
            }
            <table className="table table-bordered table-hover table-striped custome-talbe">
                <thead className='fix'>
                    <tr>
                        <td className='fixed-left _first'>{selectedItemName ? displayProductLabel(selectedItemName) : ""}</td>
                        {PastActualsOneValue && <td className='_middle _lft_border' colSpan={12} style={{ textAlign: 'center' }}> Last Yr. Actuals</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && <td className='_middle _lft_border past_actuals_2' colSpan={colSpanPastActuals} style={{ textAlign: 'center' }}> Past Actuals</td>}
                        {PastForecastOneValue && <td className=' _lft_border _last' style={{ textAlign: 'center' }} colSpan={colSpanPastForecast}>Current Week </td>}
                        {PastForecastTwoValue && <td className='_lft_border _last projected' style={{ textAlign: 'center' }} colSpan={colSpanProjected}>Projected </td>}
                    </tr>
                    <tr>
                        <DynamicTableHeader pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} weeklyRanges={weeklyRanges}
                            lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals} monthsMeta={monthsMetaBySection.pastActuals} lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                            monthsMetaBySection={monthsMetaBySection}
                        />
                    </tr>
                </thead>
                <tbody>
                    {kpi?.props?.map(item => {
                        const { color, ...restprops } = item;
                        return (<tr className={color}><DynamicTableRow {...restprops} lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals}
                            monthsMeta={monthsMetaBySection.pastActuals}
                            lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                            monthsMetaBySection={monthsMetaBySection}
                            pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                            pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                            projectedMonthlyAggregation={projectedMonthlyAggregation} pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} aggregations_union_arr={aggregations_union_arr} /></tr>)
                    })}
                    <tr className='blue'>
                        <td className='columfix fixed-left style_icons'>Stock<span className="_icons" onClick={toggleIcons}>{plusIcons ? <FaMinus /> : <FaPlus />} </span></td>
                        {PastActualsOneValue && <td colSpan='12' className='past_actuals'>&nbsp;</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && (<td colSpan={colSpanPastActuals} className='past_actuals_2'>&nbsp;</td>)}
                        {PastForecastOneValue && (<td colSpan={colSpanPastForecast} className='past_actuals_3'>&nbsp;</td>)}
                        {PastForecastTwoValue && <td colSpan={colSpanProjected} className='projected'>&nbsp;</td>}
                    </tr>
                    {plusIcons && stock?.props?.map(item => {
                        const { color, ...restprops } = item;
                        return (<tr className={color}><DynamicTableRow {...restprops} lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals}
                            monthsMeta={monthsMetaBySection.pastActuals}
                            lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                            monthsMetaBySection={monthsMetaBySection}
                            pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                            pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                            projectedMonthlyAggregation={projectedMonthlyAggregation} pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} aggregations_union_arr={aggregations_union_arr} /></tr>)
                    })}
                    <tr className='blue'>
                        <td className='columfix fixed-left style_icons'>Forecast Tertiary <span className="_icons" onClick={ForecastedTertParameters}>{forecastedTP ? <FaMinus /> : <FaPlus />} </span></td>
                        {PastActualsOneValue && <td colSpan='12' className='past_actuals'>&nbsp;</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && (<td colSpan={colSpanPastActuals} className='past_actuals_2'>&nbsp;</td>)}
                        {PastForecastOneValue && (<td colSpan={colSpanPastForecast} className='past_actuals_3'>&nbsp;</td>)}
                        {PastForecastTwoValue && <td colSpan={colSpanProjected} className='projected'>&nbsp;</td>}
                    </tr>
                    {forecastedTP && forecastTertiary?.props?.map(item => {
                        const { color, ...restprops } = item;
                        return (<tr className={color}><DynamicTableRow {...restprops} lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals}
                            monthsMeta={monthsMetaBySection.pastActuals}
                            lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                            monthsMetaBySection={monthsMetaBySection}
                            pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                            pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                            projectedMonthlyAggregation={projectedMonthlyAggregation} pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} aggregations_union_arr={aggregations_union_arr} /></tr>)
                    })}
                    <tr className='blue'>
                        <td className='columfix fixed-left style_icons'>Drivers <span className="_icons" onClick={StockoutletHandle}>{stockoutlet ? <FaMinus /> : <FaPlus />} </span></td>
                        {PastActualsOneValue && <td colSpan='12' className='past_actuals'>&nbsp;</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && (<td colSpan={colSpanPastActuals} className='past_actuals_2'>&nbsp;</td>)}
                        {PastForecastOneValue && (<td colSpan={colSpanPastForecast} className='past_actuals_3'>&nbsp;</td>)}
                        {PastForecastTwoValue && <td colSpan={colSpanProjected} className='projected'>&nbsp;</td>}
                    </tr>
                    {stockoutlet && (
                        <>
                            {drivers?.props?.map((item, rowIndex) => {
                                const { color, ...restprops } = item;
                                return (
                                    <tr key={`drivers-${rowIndex}`} className={color}>
                                        <DynamicTableRow {...restprops} lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals}
                                            monthsMeta={monthsMetaBySection.pastActuals}
                                            lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                                            monthsMetaBySection={monthsMetaBySection}
                                            pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                                            pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                                            projectedMonthlyAggregation={projectedMonthlyAggregation} pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} aggregations_union_arr={aggregations_union_arr} />
                                    </tr>
                                );
                            })}
                        </>
                    )}


                    <tr className='blue'>
                        <td className='columfix fixed-left style_icons'>Exposure <span className="_icons" onClick={exposureFunction}>{exposure ? <FaMinus /> : <FaPlus />} </span></td>
                        {PastActualsOneValue && <td colSpan='12' className='past_actuals'>&nbsp;</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && <td colSpan={colSpanPastActuals} className='past_actuals_2'>&nbsp;</td>}
                        {PastForecastOneValue && <td colSpan={colSpanPastForecast} className='past_actuals_3'>&nbsp;</td>}
                        {PastForecastTwoValue && <td colSpan={colSpanProjected} className='projected'>&nbsp;</td>}
                    </tr>
                    {exposure && (<>
                        {/* <tr className="green"><DynamicTableRow rowData='Exposure' /></tr>
                        <tr className="green"><DynamicTableRow rowData='Exposure DOS' title="Exposure DOS (Forecast Tert.)" /></tr> */}
                        {exposureProps && exposureProps.props.map(item => {
                            const { color, ...restProps } = item;
                            return (<tr className={color}><DynamicTableRow {...restProps} lastWeekIndexToMonthIdx={lastWeekIndexToMonthIdxBySection.pastActuals}
                                monthsMeta={monthsMetaBySection.pastActuals}
                                lastWeekIndexToMonthIdxBySection={lastWeekIndexToMonthIdxBySection}
                                monthsMetaBySection={monthsMetaBySection}
                                pastActualsMonthlyAggregation={pastActualsMonthlyAggregation}
                                pastForecastMonthlyAggregation={pastForecastMonthlyAggregation}
                                projectedMonthlyAggregation={projectedMonthlyAggregation} pastActualsCount={pastActualsEnd} forecastCount={Math.max(0, forecastCount)} projectionCount={Math.max(0, projectionCount)} aggregations_union_arr={aggregations_union_arr} /></tr>)
                        })}
                    </>)}
                    <tr className="white border-gray-300 border-t-2">
                        <td colSpan={24} className='border-b-1 border-gray-300 h-1' style={{ height: '10px', padding: '0px' }}></td>
                    </tr>
                    <tr id="input-section" className='blue'>
                        <td className='columfix fixed-left style_icons'>Input <span className="_icons" onClick={dbrDos}>{dbrDosvalue ? <FaMinus /> : <FaPlus />} </span></td>
                        {PastActualsOneValue && <td colSpan='12' className='past_actuals'>&nbsp;</td>}
                        {colSpanPastActuals > 0 && PastActualsTwoValue && (<td colSpan={colSpanPastActuals} className='past_actuals_2'>&nbsp;</td>)}
                        {PastForecastOneValue && (<td colSpan={colSpanPastForecast} className='past_actuals_3'>&nbsp;</td>)}
                        {PastForecastTwoValue && <td colSpan={colSpanProjected} className='projected'>&nbsp;</td>}
                    </tr>

                    {/* {dbrDosvalue && inputs.props.map(({ color, rowData, inputName, monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [] }, rowIndex) => {
                        const isRowSelected = highlightedInputRow === rowIndex;
                        return (
                            <tr
                                key={rowIndex}
                                data-row-index={rowIndex}
                                className={`${color} ${isRowSelected ? 'proj-row-selected' : ''}`}
                                onClick={() => {
                                    setHighlightedInputRow(rowIndex);
                                    if (highlightedProjIdx == null) setHighlightedProjIdx(0);
                                }}
                                role="row"
                            >
                                <td className='columfix fixed-left'>{rowData}</td>

                                {PastActualsOneValue && monthlyValues.map((val, i) => (
                                    <td key={i} className='past_actuals'>{val === 0 ? "-" : val.toLocaleString('en-IN')}</td>
                                ))}

                                {PastActualsTwoValue && weeklyValues.map((val, i) => (
                                    <td key={i} className='past_actuals_2'>{val === 0 ? "-" : val.toLocaleString('en-IN')}</td>
                                ))}

                                {PastForecastOneValue && forecastValues.map((val, i) => (
                                    <td key={i} className='past_actuals_3'>{val === 0 ? "-" : val.toLocaleString('en-IN')}</td>
                                ))}

                                {PastForecastTwoValue && projectionValues.map((val, i) => {
                                    const displayValue = isEditEnabled ? (val == null ? '-' : String(val)) : (typeof val === 'number' ? val.toLocaleString('en-IN') : (val ?? '-'));

                                    return (
                                        <td
                                            key={i}
                                            data-projection-index={i}
                                            className={`projected ${isRowSelected ? 'proj-row-selected-cell' : ''}`}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setHighlightedInputRow(rowIndex);
                                                setHighlightedProjIdx(i);
                                            }}
                                            role="gridcell"
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    setHighlightedInputRow(rowIndex);
                                                    setHighlightedProjIdx(i);
                                                }
                                            }}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <input
                                                disabled={!isEditEnabled}
                                                type="text"
                                                className="form-control custome-text"
                                                value={displayValue}
                                                title={displayValue}
                                                onChange={(e) => {
                                                    handleInputEditChange(inputName, i, e.target.value);
                                                    setHighlightedInputRow(rowIndex);
                                                    setHighlightedProjIdx(i);
                                                }}
                                                onFocus={() => {
                                                    // suppress while focused (immediately)
                                                    suppressScrollRef.current = true;
                                                    if (suppressTimeoutRef.current) { clearTimeout(suppressTimeoutRef.current); suppressTimeoutRef.current = null; }
                                                }}
                                                onBlur={() => {
                                                    // allow a short delay after blur then run one alignment
                                                    if (suppressTimeoutRef.current) clearTimeout(suppressTimeoutRef.current);
                                                    suppressTimeoutRef.current = setTimeout(() => {
                                                        suppressScrollRef.current = false;
                                                        suppressTimeoutRef.current = null;
                                                        try { scrollProjectionIntoViewOnce(); } catch (e) { }
                                                    }, 140);
                                                }}
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setHighlightedInputRow(rowIndex);
                                                    setHighlightedProjIdx(i);
                                                }}
                                            />

                                        </td>
                                    );
                                })}
                            </tr>
                        );
                    })} */}

                    {dbrDosvalue && inputs.props.map(({ color, rowData, inputName, monthlyValues = [], weeklyValues = [], forecastValues = [], projectionValues = [] }, rowIndex) => {
                        const isRowSelected = highlightedInputRow === rowIndex;
                        // compute global base indexes for each section (0-based)
                        const basePastActualsGlobal = 0;
                        const basePastForecastGlobal = (pastActualsCount || 0);
                        const baseProjectedGlobal = (pastActualsCount || 0) + (forecastCount || 0);

                        return (
                            <tr
                                key={rowIndex}
                                data-row-index={rowIndex}
                                className={`${color} ${isRowSelected ? 'proj-row-selected' : ''}`}
                                onClick={() => {
                                    setHighlightedInputRow(rowIndex);
                                    if (highlightedProjIdx == null) setHighlightedProjIdx(0);
                                }}
                                role="row"
                            >
                                <td className='columfix fixed-left'>{rowData}</td>

                                {/* last-year months */}
                                {PastActualsOneValue && monthlyValues.map((val, i) => (
                                    <td key={`m-${rowIndex}-${i}`} className='past_actuals'>
                                        {val === 0 ? '-' : (val == null ? '-' : (typeof val === 'number' ? val.toLocaleString('en-IN') : val))}
                                    </td>
                                ))}

                                {/* past actuals weekly + monthly-agg inserted */}
                                {PastActualsTwoValue && renderWeeklyWithMonthlyForInput(weeklyValues, 'pastActuals', basePastActualsGlobal, inputName)}

                                {/* past forecast weekly + monthly-agg inserted */}
                                {PastForecastOneValue && renderWeeklyWithMonthlyForInput(forecastValues, 'pastForecast', basePastForecastGlobal, inputName)}

                                {/* projected weekly + monthly-agg inserted (these cells include input edit controls in your original code) */}
                                {PastForecastTwoValue && (() => {
                                    // For projected, you previously rendered inputs. We will render the weekly/projection cells with inputs
                                    // while also inserting monthly-aggregate cells after the last-week-of-month.
                                    const cells = [];
                                    const projVals = projectionValues || [];
                                    for (let i = 0; i < projVals.length; i++) {
                                        const v = projVals[i];
                                        const globalIdx = (baseProjectedGlobal + i) % MAX_WEEK_NUM;
                                        const cellClass = 'projected';
                                        const displayValue = isEditEnabled ? (v == null ? '-' : String(v)) : (typeof v === 'number' ? v.toLocaleString('en-IN') : (v ?? '-'));

                                        cells.push(
                                            <td
                                                key={`proj-wk-${rowIndex}-${i}`}
                                                data-projection-index={i}
                                                className={`${cellClass} ${isRowSelected ? 'proj-row-selected-cell' : ''}`}
                                                onClick={(e) => { e.stopPropagation(); setHighlightedInputRow(rowIndex); setHighlightedProjIdx(i); }}
                                                role="gridcell"
                                                tabIndex={0}
                                                onKeyDown={(e) => { if (e.key === 'Enter') { e.preventDefault(); setHighlightedInputRow(rowIndex); setHighlightedProjIdx(i); } }}
                                                style={{ cursor: 'pointer' }}
                                            >
                                                <input
                                                    disabled={!isEditEnabled}
                                                    type="text"
                                                    className="form-control custome-text"
                                                    value={displayValue}
                                                    title={displayValue}
                                                    onChange={(e) => {
                                                        handleInputEditChange(inputName, i, e.target.value);
                                                        setHighlightedInputRow(rowIndex);
                                                        setHighlightedProjIdx(i);
                                                    }}
                                                    onFocus={() => {
                                                        suppressScrollRef.current = true;
                                                        if (suppressTimeoutRef.current) { clearTimeout(suppressTimeoutRef.current); suppressTimeoutRef.current = null; }
                                                    }}
                                                    onBlur={() => {
                                                        if (suppressTimeoutRef.current) clearTimeout(suppressTimeoutRef.current);
                                                        suppressTimeoutRef.current = setTimeout(() => {
                                                            suppressScrollRef.current = false;
                                                            suppressTimeoutRef.current = null;
                                                            try { scrollProjectionIntoViewOnce(); } catch (e) { }
                                                        }, 140);
                                                    }}
                                                    onClick={(e) => { e.stopPropagation(); setHighlightedInputRow(rowIndex); setHighlightedProjIdx(i); }}
                                                />
                                            </td>
                                        );

                                        // insert monthly aggregated cell after the week if month ends here
                                        const monthIdx = getMonthIdxForGlobalWeek('projected', globalIdx);
                                        if (monthIdx !== null && monthIdx !== undefined) {
                                            const monthlyVals = findMonthlyArrayForInput(projectedMonthlyAggregation, inputName);
                                            const mVal = monthlyVals ? monthlyVals[monthIdx] : null;
                                            cells.push(
                                                <td key={`proj-mon-${rowIndex}-${globalIdx}`} className={`${cellClass} monthly-agg`}>
                                                    {mVal == null || mVal === 0 ? '-' : (typeof mVal === 'number' ? mVal.toLocaleString('en-IN') : mVal)}
                                                </td>
                                            );
                                        }
                                    }
                                    return cells;
                                })()}
                            </tr>
                        );
                    })}

                </tbody>
            </table>
        </div>
    )
}


